import { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function OutlineIcon({ path, ...svgProps }: IconProps & { path: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      aria-hidden="true"
      {...svgProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d={path} />
    </svg>
  );
}

export function ChevronDoubleLeftIcon(props: IconProps) {
  return (
    <OutlineIcon
      path={"m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"}
      {...props}
    />
  );
}

export function ChevronDoubleRightIcon(props: IconProps) {
  return (
    <OutlineIcon
      path={"m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"}
      {...props}
    />
  );
}
